import '@/assets/css/fontawesome.min.css'
import '@/assets/scss/index.scss'

import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import router from './router'
import store from './store'
import lodash from 'lodash'
import VeeValidate from 'vee-validate'
import Notification from '@/plugins/notifications/index.js'
import i18n from '@/plugins/i18n'
import vClickOutside from 'v-click-outside'
import Default from './layout/Default'
import Login from './layout/Login'
import VideoLayout from './layout/VideoLayout'
import VueNativeSock from 'vue-native-websocket'

Vue.use(
  VueNativeSock,
  (window.location.protocol === 'https:' ? 'wss://' : 'ws://') +
    (process.env.VUE_APP_API_DAMIN || window.location.host) +
    '/api/notification/websocket',
  {
    store: store,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 3000
  }
)
Vue.use(Notification)
Vue.use(VeeValidate)
Vue.use(vClickOutside)
Vue.use(Buefy, {
  defaultIconPack: 'fas'
})
Vue.config.productionTip = false
Vue.prototype.$lodash = lodash

Vue.component('default', Default)
Vue.component('login', Login)
Vue.component('videolayout', VideoLayout)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
